import SiafLiteApiRepository from "../../external/siafLiteApi";

class BancosCaixasConveniosService {
  constructor() {
    this.urlBase = "/financeiro/bancos-caixas-convenios";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }
}

export default BancosCaixasConveniosService;
